import React, {useMemo, useState, useEffect} from 'react';
import { useSelector } from 'react-redux';
import { t } from '../../content';
import B2BApiService from "../../B2bApiService";
import checkGreen from '../../assets/images/icons/checkGreen.svg';
import checklistGreen from '../../assets/images/icons/checklistGreen.svg';
import calendarGreen from '../../assets/images/icons/calendarGreen.svg';
import personWithSuitcaseGreen from '../../assets/images/icons/personWithSuitcaseGreen.svg';
import shieldGreen from '../../assets/images/icons/shieldGreen.png';

import * as Constants from "../../constants";

function HomeQuickStart({userRole}) {   
    // const data = useSelector( state => state.contentfulData.all['home page no data']);
    const companyData = useSelector( state => state.company.info);
    const [userData, setUserData] = useState(null);

    let stepCompleted = false;

    const b2bServiceObj = useMemo(() => {
        return new B2BApiService();
    }, []);

    useEffect(() => {
        b2bServiceObj.LoadUserData((userData) => {
            setUserData(userData);
        })
    }, [b2bServiceObj]);

    return ( // WE USE A DIFFERENT QUICKSTART FOR ADMININISTRATIVE USERS, AS THEY DONOT HAVE OPERATIONAL FEATURES
            <div className="onboarding">
                <h3 className="extra-light m-0">{t('dashboard.quickStartTitle')} {userData?.first || ''} {userData?.last || ''}</h3>
                <h2 className="company-name bold">{companyData?.name}</h2>
                <h4 className="quickstart extra-light">{t('dashboard.quickStartGuide')}</h4>
                <ul className="steps-wrapper p-0 m-0"> 
                    {userRole && [Constants.USER_ROLE_OWNER].includes(userRole) ?
                        <>
                            <li className="step">
                                <img src={stepCompleted ? checkGreen : checklistGreen} alt="" />
                                <a href="/settings"><p className={stepCompleted ? 'm-0 m medium grey' : 'm-0 m medium'}>{t('dashboard.steps.manageCompanyProfile')}</p></a>
                            </li>
                            <li className="step">
                                <img src={stepCompleted ? checkGreen : personWithSuitcaseGreen} alt="" />
                                <a href="/corporate-settings"><p className={stepCompleted ? 'm-0 m medium grey' : 'm-0 m medium'}>{t('dashboard.steps.manageCorporateUsers')}</p></a>
                            </li>
                            <li className="step">
                                <img src={stepCompleted ? checkGreen : shieldGreen} alt="" />
                                <a href="/corporate-settings"><p className={stepCompleted ? 'm-0 m medium grey' : 'm-0 m medium'}>{t('dashboard.steps.manageUserRoles')}</p></a>
                            </li>
                        </>
                        :
                        <>
                            <li className="step">
                                <img src={stepCompleted ? checkGreen : checklistGreen} alt="" />
                                <a href="/settings"><p className={stepCompleted ? 'm-0 s medium grey' : 'm-0 s medium'}>{[Constants.USER_ROLE_ADMIN, Constants.USER_ROLE_HRD].includes(userRole) ? t('dashboard.steps.manageCompanyProfile') : t('dashboard.steps.viewCompanyProfile')}</p></a>
                            </li>
                            <li className="step">
                                <img src={stepCompleted ? checkGreen : checklistGreen} alt="" />
                                <a href="/team-review"><p className={stepCompleted ? 'm-0 s medium grey' : 'm-0 s medium'}>{t('dashboard.steps.createTeam')}</p></a>
                            </li>
                            <li className="step">
                                <img src={stepCompleted ? checkGreen : calendarGreen} alt="" />
                                <a href="/team-analytics"><p className={stepCompleted ? 'm-0 s medium grey' : 'm-0 s medium'}>{t('dashboard.steps.auditTeam')}</p></a>
                            </li>
                            <li className="step">
                                <img src={stepCompleted ? checkGreen : personWithSuitcaseGreen} alt="" />
                                <a href="/open-positions"><p className={stepCompleted ? 'm-0 s medium grey' : 'm-0 s medium'}>{t('dashboard.steps.createPosition')}</p></a>
                            </li>
                        </>
                    }
                </ul>
            </div>
        )
}

export default HomeQuickStart;
